webpackJsonp([1],{

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dbRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dbCtgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(366);




var config = { // 본인의 설정으로 진행
  apiKey: "AIzaSyAUqZc_6mGWUiG34_cGWgk56nDF_1WL7dQ",
  authDomain: "osp18-5.firebaseapp.com",
  databaseURL: "https://osp18-5.firebaseio.com",
  projectId: "osp18-5",
  storageBucket: "osp18-5.appspot.com",
  messagingSenderId: "581938170150"
};

__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(config);

var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.firestore();
db.settings({
  timestampsInSnapshots: true
});
var dbRef = db.collection('todos');
var dbCtgs = db.collection('category');

var authRef = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth();
authRef.setPersistence(__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth.Auth.Persistence.SESSION);
var gProvider = new __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth.GoogleAuthProvider();



/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__route_index_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_full_calendar__ = __webpack_require__(397);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

 // store 사용
 // route 사용


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_full_calendar__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
   el: '#app',
   store: __WEBPACK_IMPORTED_MODULE_5__store_store_js__["a" /* store */], // store 사용
   router: __WEBPACK_IMPORTED_MODULE_6__route_index_js__["a" /* default */], // route 사용
   template: '<App/>',
   components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0283c522_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(244);
function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0283c522_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 238:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoHeader_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_328f165d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoHeader_vue__ = __webpack_require__(243);
function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-328f165d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_328f165d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 241:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var proxy = 'https://cors-anywhere.herokuapp.com/';
var API_KEY = 'a3e4ec1109cc18deb8c1597d6cd38238';
var location = '37.8267,-122.4233';
var WEATHER_API_URL = proxy + 'https://api.darksky.net/forecast/' + API_KEY + '/';
var GEO_API_URL = proxy + 'https://darksky.net/geo?q=';
var ADDRESS_API_URL = proxy + 'https://darksky.net/rgeo?hires=1';

function getCoordinates(location) {
  return fetch('' + GEO_API_URL + location).then(function (response) {
    return response.json();
  });
}

function getForecast(lat, lng) {
  return fetch('' + WEATHER_API_URL + lat + ',' + lng).then(function (response) {
    return response.json();
  });
}

function getAddress(lat, lng) {
  return fetch(ADDRESS_API_URL + '&lat=' + lat + '&lon=' + lng).then(function (response) {
    return response.json();
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getAddress: getAddress,
  getForecast: getForecast,
  getCoordinates: getCoordinates
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{staticClass:"emo",attrs:{"cols":"2"}},[(_vm.forecast)?_c('span',[_c('span',{staticClass:"emoji"},[_vm._v(_vm._s(_vm.icons[_vm.forecast.currently.icon]))])]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"info",attrs:{"cols":"2"}},[(_vm.forecast)?_c('span',[_c('div',{staticClass:"summary"},[_vm._v(_vm._s(_vm.forecast.currently.summary))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.temperature)+"℃")])]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"title",attrs:{"cols":"4"}},[_c('h1',[_c('router-link',{staticClass:"brand-logo",attrs:{"to":"/"}},[_vm._v("To do it!")])],1)]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_vm._v("\n          \n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TodoHeader'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__db_js__ = __webpack_require__(13);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]); // vuex 사용

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({ // store export
    state: {
        temp: [],
        todoItems: [],
        categories: [],
        userAuth: {
            status: false,
            email: "",
            name: ""
        }
    },
    getters: {
        getTodos: function getTodos(state) {
            return state.todoItems;
        },
        getAuth: function getAuth(state) {
            return state.userAuth;
        },
        getCtgs: function getCtgs(state) {
            return state.categories;
        },
        getEmail: function getEmail(state) {
            return state.userAuth.email;
        }
    },
    mutations: {
        addTodo: function addTodo(state, value) {
            state.todoItems.push(value);
        },
        clearAll: function clearAll(state) {
            state.todoItems = [];
        },
        userAuth: function userAuth(state, value) {
            state.userAuth.status = true;
            state.userAuth.email = value.email;
            state.userAuth.name = value.displayName;
        },
        logOut: function logOut(state) {
            state.userAuth.status = false;
            state.userAuth.email = "";
            state.userAuth.name = "";
        },
        clearCtgs: function clearCtgs(state) {
            state.categories = [];
        },
        addCtgs: function addCtgs(state, value) {
            state.categories.push(value);
        }
    },
    actions: {
        clearAll: function clearAll(context, time) {
            // 비동기 작업 수행 후 mutation commit
            setTimeout(function () {
                return context.commit('clearAll');
            }, time);
        },
        getTodos: function getTodos(context) {
            __WEBPACK_IMPORTED_MODULE_2__db_js__["c" /* dbRef */].onSnapshot(function (query) {
                context.commit('clearAll');
                query.forEach(function (doc) {
                    var todo = {
                        'user': doc.data().user,
                        'id': doc.id,
                        'ctg': doc.data().ctg,
                        'title': doc.data().title,
                        'content': doc.data().content,
                        'deadline': doc.data().deadline,
                        'status': doc.data().status,
                        'remove': doc.data().remove
                    };
                    context.commit('addTodo', todo);
                });
            });
        },
        getCtgs: function getCtgs(context) {
            __WEBPACK_IMPORTED_MODULE_2__db_js__["b" /* dbCtgs */].onSnapshot(function (query) {
                context.commit('clearCtgs');
                query.forEach(function (doc) {
                    context.commit('addCtgs', {
                        'value': doc.data().category,
                        'text': doc.data().category,
                        'user': doc.data().user
                    });
                });
            });
        },
        removeTodo: function removeTodo(context, payload) {
            __WEBPACK_IMPORTED_MODULE_2__db_js__["c" /* dbRef */].doc(payload).delete();
        },
        removeCtg: function removeCtg(context, payload) {
            __WEBPACK_IMPORTED_MODULE_2__db_js__["b" /* dbCtgs */].doc(payload).delete();
        },
        BinTodo: function BinTodo(context, payload) {
            __WEBPACK_IMPORTED_MODULE_2__db_js__["c" /* dbRef */].doc(payload).update({
                remove: true
            });
        },
        RestoreTodo: function RestoreTodo(context, payload) {
            __WEBPACK_IMPORTED_MODULE_2__db_js__["c" /* dbRef */].doc(payload).update({
                remove: false
            });
        },
        DeleteComplete: function DeleteComplete(context) {
            __WEBPACK_IMPORTED_MODULE_2__db_js__["c" /* dbRef */].onSnapshot(function (query) {
                query.forEach(function (doc) {
                    var todo = {
                        'user': doc.data().user,
                        'id': doc.id,
                        'remove': doc.data().remove
                    };
                    if (todo.user == context.state.userAuth.email && todo.remove == true) {
                        __WEBPACK_IMPORTED_MODULE_2__db_js__["c" /* dbRef */].doc(todo.id).delete();
                    }
                });
            });
        },
        DoneTodo: function DoneTodo(context, payload) {
            __WEBPACK_IMPORTED_MODULE_2__db_js__["c" /* dbRef */].doc(payload.id).update({
                status: !payload.status
            });
        },
        addTodo: function addTodo(context, value) {
            var id = Date.now().toString();
            __WEBPACK_IMPORTED_MODULE_2__db_js__["c" /* dbRef */].doc(id).set({
                'id': Date.now().toString(),
                'user': context.state.userAuth.email,
                'ctg': value.ctg,
                'title': value.title,
                'content': value.content,
                'deadline': value.deadline,
                'status': false,
                'remove': false
            });
        },
        addCtg: function addCtg(context, value) {
            var id = value;
            __WEBPACK_IMPORTED_MODULE_2__db_js__["b" /* dbCtgs */].doc(id).set({
                'user': context.state.userAuth.email,
                'category': value
            });
        },
        userAuth: function userAuth(context) {
            __WEBPACK_IMPORTED_MODULE_2__db_js__["a" /* authRef */].signInWithPopup(__WEBPACK_IMPORTED_MODULE_2__db_js__["d" /* gProvider */]).then(function (result) {
                context.commit('userAuth', result.user);
            });
        },
        logOut: function logOut(context) {
            __WEBPACK_IMPORTED_MODULE_2__db_js__["a" /* authRef */].signOut().then(function () {
                context.commit('userAuth');
            });
        }
    }
});

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TodoContents__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TodoLogin__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TodoNew__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TodoView__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TodoEdit__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TodoBin__ = __webpack_require__(394);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_3__components_TodoLogin__["a" /* default */] }, { path: '/todo', name: 'Todolist', component: __WEBPACK_IMPORTED_MODULE_2__components_TodoContents__["a" /* default */] }, { path: '*', component: __WEBPACK_IMPORTED_MODULE_3__components_TodoLogin__["a" /* default */] }, { path: '/create', component: __WEBPACK_IMPORTED_MODULE_4__components_TodoNew__["a" /* default */] }, { path: '/view/:todo_id', name: 'Todoview', component: __WEBPACK_IMPORTED_MODULE_5__components_TodoView__["a" /* default */] }, { path: '/edit/:todo_id', name: 'Todoedit', component: __WEBPACK_IMPORTED_MODULE_6__components_TodoEdit__["a" /* default */] }, { path: '/bin', name: 'Todobin', component: __WEBPACK_IMPORTED_MODULE_7__components_TodoBin__["a" /* default */] }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoContents_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_498a7e14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoContents_vue__ = __webpack_require__(379);
function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoContents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_498a7e14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoContents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoList_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f19649_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoList_vue__ = __webpack_require__(376);
function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58f19649"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f19649_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 373:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.$emit('close')}}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"close"},[_vm._t("close")],2),_vm._v(" "),_c('div',{staticClass:"modal-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer")],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"todo-list"}},[_c('div',{staticClass:"progress"},[_vm._m(0),_vm._v(" \n    "),_c('div',{staticClass:"progress-bar progress-bar-striped active",style:({width: _vm.done + '%'}),attrs:{"role":"progressbar","aria-valuenow":"40","aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("\n      "+_vm._s(_vm.done)+"%\n    ")])]),_vm._v(" "),_c('div',[_c('b-form',{attrs:{"inline":""}},[_c('b-form-select',{attrs:{"options":_vm.ctgs,"id":"ctg"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":null}},[_vm._v("전체보기")])]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"search","type":"text","placeholder":"Search todo"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1),_vm._v(" "),_c('div',[_c('transition-group',{staticClass:"todolist",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.filteredTodos),function(todoItem){return _c('li',{key:todoItem.id,staticClass:"shadow"},[_c('span',{staticClass:"completeBtn",on:{"click":function($event){_vm.doneTodo(todoItem)}}},[_c('i',{staticClass:"fas fa-check fa-2x",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"ctg"},[_vm._v(_vm._s(todoItem.ctg))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("summarize")(todoItem.title)))]),_vm._v(" "),_c('span',{staticClass:"deadline"},[_vm._v(_vm._s(todoItem.deadline))]),_vm._v(" "),_c('span',{staticClass:"label-default viewBtn"},[_c('router-link',{attrs:{"to":{name:'Todoview', params: {todo_id: todoItem.id}}}},[_c('i',{staticClass:"fa fa-eye"})])],1),_vm._v(" "),_c('span',{staticClass:"label-default removeBtn",on:{"click":function($event){_vm.removeTodo(todoItem.id)}}},[_c('i',{staticClass:"far fa-trash-alt fa-1.5x",attrs:{"aria-hidden":"true"}})])])})),_vm._v(" "),_c('b-row',{staticClass:"addBtn"},[_c('div',[_c('router-link',{attrs:{"to":"/create"}},[_c('i',{staticClass:"fas fa-plus-circle fa-3x"})])],1)])],1),_vm._v(" "),_c('h3',[_vm._v("Mission Complete")]),_vm._v(" "),_c('div',[_c('transition-group',{staticClass:"donelist",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.doneTodos),function(todoItem){return _c('li',{key:todoItem.id,staticClass:"shadow"},[_c('span',{staticClass:"completeBtn",on:{"click":function($event){_vm.doneTodo(todoItem)}}},[_c('i',{staticClass:"fas fa-check fa-2x",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"ctg"},[_vm._v(_vm._s(todoItem.ctg))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("summarize")(todoItem.title)))]),_vm._v(" "),_c('span',{staticClass:"deadline"},[_vm._v(_vm._s(todoItem.deadline))]),_vm._v(" "),_c('span',{staticClass:"label-default viewBtn"},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticClass:"label-default removeBtn",on:{"click":function($event){_vm.removeTodo(todoItem.id)}}},[_c('i',{staticClass:"far fa-trash-alt fa-1.5x",attrs:{"aria-hidden":"true"}})])])}))],1),_vm._v(" "),(_vm.showModal)?_c('modal',{staticClass:"alarm",on:{"click":function($event){_vm.showModal = false}}},[_c('span',{attrs:{"slot":"header"},slot:"header"},[_c('h3',{staticStyle:{"color":"red"}},[_vm._v("마감 하루 전")])]),_vm._v(" "),_c('span',{staticClass:"alarmmodal",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"alarmlist",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.deadlineTodos),function(todoItem){return _c('li',{key:todoItem.id,staticClass:"shadow"},[_c('span',{staticClass:"alarmCtg"},[_vm._v(_vm._s(todoItem.ctg))]),_vm._v(" "),_c('span',{staticClass:"alarmTitle"},[_vm._v(_vm._s(_vm._f("summarize")(todoItem.title)))])])})),_vm._v(" "),_c('b-button',{staticStyle:{"margin-top":"2rem"},attrs:{"variant":"success"},on:{"click":function($event){_vm.showModal=false}}},[_vm._v("확인")])],1)]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('h4',[_vm._v("완료")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav-todo"}},[_c('b-nav',[_c('b-nav-item',{on:{"click":_vm.logOut}},[_vm._v("Logout")]),_vm._v(" "),_c('b-nav-item',{on:{"click":_vm.todoBin}},[_vm._v("휴지통")]),_vm._v(" "),_c('b-nav-item',{on:{"click":_vm.todoList}},[_vm._v("할일목록")]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('strong',[_vm._v(_vm._s(_vm.name))]),_vm._v("님")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responsive"},[_c('TodoNav'),_vm._v(" "),_c('TodoList')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoLogin_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3840b70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoLogin_vue__ = __webpack_require__(384);
function injectStyle (ssrContext) {
  __webpack_require__(381)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3840b70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 381:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"loginForm",attrs:{"title":"You need LOGIN","img-src":"https://images.unsplash.com/photo-1509822929063-6b6cfc9b42f2?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=e1f57036c9c3ef1d85d9ea7bc19ccb57&auto=format&fit=crop&w=300&q=40","img-alt":"Image","img-top":"","tag":"article"}},[_c('b-button',{attrs:{"size":"lg","variant":"primary"},on:{"click":_vm.gLogin}},[_vm._v("Google Login")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoNew_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632f71b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoNew_vue__ = __webpack_require__(387);
function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-632f71b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632f71b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 386:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"input-todo"}},[_c('h1',[_vm._v("New Todo")]),_vm._v(" "),_c('b-form',{on:{"reset":_vm.onReset}},[_c('h3',[_vm._v("\n      Category\n      "),_c('span',{on:{"click":function($event){_vm.showCtg = !_vm.showCtg}}},[_c('i',{staticClass:"fas fa-cog fa-0.6x"})])]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.ctgs},model:{value:(_vm.form.ctg),callback:function ($$v) {_vm.$set(_vm.form, "ctg", $$v)},expression:"form.ctg"}}),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Title")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter your name"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}}),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Content")]),_vm._v("\n    "+_vm._s(_vm.form.user)+"\n    "),_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Enter something","rows":3,"max-rows":6},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}}),_c('br'),_vm._v(" "),_c('h3',[_vm._v("DeadLine")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.form.deadline),callback:function ($$v) {_vm.$set(_vm.form, "deadline", $$v)},expression:"form.deadline"}}),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("Submit")]),_vm._v(" "),_c('b-button',{attrs:{"type":"reset","variant":"danger"}},[_vm._v("Reset")])],1),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("경고")]),_vm._v(" "),_c('span',{staticStyle:{"margin-right":"4rem"},attrs:{"slot":"footer"},on:{"click":function($event){_vm.showModal = false}},slot:"footer"},[_vm._v("\n       모든 입력 폼을 채워주세요\n       "),_c('i',{staticClass:"closeModalBtn fas fa-times",attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),(_vm.showCtg)?_c('modal',{on:{"close":function($event){_vm.showCtg = false}}},[_c('b-button',{attrs:{"slot":"close","variant":"danger"},on:{"click":function($event){_vm.showCtg=false}},slot:"close"},[_vm._v("닫기")]),_vm._v(" "),_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("카테고리 설정")]),_vm._v(" "),_c('div',{staticClass:"ctgSet",attrs:{"slot":"content"},slot:"content"},[_c('ul',_vm._l((_vm.ctgs),function(ctg){return _c('li',{key:ctg.value},[_vm._v("\n           "+_vm._s(ctg.value)+"\n           "),_c('span',{on:{"click":function($event){_vm.deleteCtg(ctg.value)}}},[_c('i',{staticClass:"fas fa-times-circle",staticStyle:{"color":"red"}})])])}))]),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-form',{attrs:{"inline":""}},[_c('b-input',{staticStyle:{"font-size":"1.3rem"},model:{value:(_vm.newCtg),callback:function ($$v) {_vm.newCtg=$$v},expression:"newCtg"}}),_vm._v(" "),_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.addCtg}},[_vm._v("추가")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoView_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a952df3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoView_vue__ = __webpack_require__(390);
function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a952df3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a952df3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 389:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-todo"}},[_c('h1',[_vm._v("Todo View")]),_vm._v(" "),_c('b-form',[_c('h3',[_vm._v("Category")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.form.ctg),callback:function ($$v) {_vm.$set(_vm.form, "ctg", $$v)},expression:"form.ctg"}}),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Title")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter your name","disabled":""},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}}),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Content")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Enter something","rows":3,"max-rows":6,"disabled":""},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}}),_c('br'),_vm._v(" "),_c('h3',[_vm._v("DeadLine")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":""},model:{value:(_vm.form.deadline),callback:function ($$v) {_vm.$set(_vm.form, "deadline", $$v)},expression:"form.deadline"}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('router-link',{attrs:{"to":"/"}},[_c('b-button',[_vm._v("뒤로가기")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":{name:'Todoedit', params: {todo_id: this.$route.params.todo_id}}}},[_c('b-button',{attrs:{"variant":"success"}},[_vm._v("수정하기")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoEdit_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45b6980c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoEdit_vue__ = __webpack_require__(393);
function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45b6980c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45b6980c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 392:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-todo"}},[_c('h1',[_vm._v("Todo Edit")]),_vm._v(" "),_c('b-form',[_c('h3',[_vm._v("Category")]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.ctgs},model:{value:(_vm.form.ctg),callback:function ($$v) {_vm.$set(_vm.form, "ctg", $$v)},expression:"form.ctg"}}),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Title")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter your name"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}}),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Content")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Enter something","rows":3,"max-rows":6},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}}),_c('br'),_vm._v(" "),_c('h3',[_vm._v("DeadLine")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.form.deadline),callback:function ($$v) {_vm.$set(_vm.form, "deadline", $$v)},expression:"form.deadline"}}),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.onSubmit}},[_vm._v("수정완료")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name:'Todoview', params: {todo_id: this.$route.params.todo_id}}}},[_c('b-button',[_vm._v("취소하기")])],1)],1),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("경고")]),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},on:{"click":function($event){_vm.showModal = false}},slot:"footer"},[_vm._v("할 일을 입력하세요.\n       "),_c('i',{staticClass:"closeModalBtn fas fa-times",attrs:{"aria-hidden":"true"}})])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoBin_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1060ee9a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoBin_vue__ = __webpack_require__(396);
function injectStyle (ssrContext) {
  __webpack_require__(395)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1060ee9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoBin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1060ee9a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoBin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 395:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"todo-bin"}},[_c('TodoNav'),_vm._v(" "),_c('h1',[_vm._v("휴지통")]),_vm._v(" "),_c('transition-group',{attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.filteredTodos),function(todoItem){return _c('li',{key:todoItem.id,staticClass:"shadow"},[_c('span',{staticClass:"ctg"},[_vm._v(_vm._s(todoItem.ctg))]),_vm._v(" "),_c('span',{staticClass:"title"},[_c('span',{class:{text: todoItem.status}},[_vm._v("\n          "+_vm._s(todoItem.title)+"\n        ")])]),_vm._v(" "),_c('span',{staticClass:"deadline"},[_vm._v("\n        "+_vm._s(todoItem.deadline)+"\n      ")]),_vm._v(" "),_c('span',{staticClass:"restoreBtn",on:{"click":function($event){_vm.restoreTodo(todoItem.id)}}},[_c('i',{staticClass:"fas fa-recycle"})])])})),_vm._v(" "),_c('div',{staticClass:"remove"},[_c('b-button',{attrs:{"size":"lg","variant":"danger"},on:{"click":_vm.removeAll}},[_vm._v("휴지통 비우기")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75db3bf7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__ = __webpack_require__(429);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75db3bf7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 110,
	"./af.js": 110,
	"./ar": 111,
	"./ar-dz": 112,
	"./ar-dz.js": 112,
	"./ar-kw": 113,
	"./ar-kw.js": 113,
	"./ar-ly": 114,
	"./ar-ly.js": 114,
	"./ar-ma": 115,
	"./ar-ma.js": 115,
	"./ar-sa": 116,
	"./ar-sa.js": 116,
	"./ar-tn": 117,
	"./ar-tn.js": 117,
	"./ar.js": 111,
	"./az": 118,
	"./az.js": 118,
	"./be": 119,
	"./be.js": 119,
	"./bg": 120,
	"./bg.js": 120,
	"./bm": 121,
	"./bm.js": 121,
	"./bn": 122,
	"./bn.js": 122,
	"./bo": 123,
	"./bo.js": 123,
	"./br": 124,
	"./br.js": 124,
	"./bs": 125,
	"./bs.js": 125,
	"./ca": 126,
	"./ca.js": 126,
	"./cs": 127,
	"./cs.js": 127,
	"./cv": 128,
	"./cv.js": 128,
	"./cy": 129,
	"./cy.js": 129,
	"./da": 130,
	"./da.js": 130,
	"./de": 131,
	"./de-at": 132,
	"./de-at.js": 132,
	"./de-ch": 133,
	"./de-ch.js": 133,
	"./de.js": 131,
	"./dv": 134,
	"./dv.js": 134,
	"./el": 135,
	"./el.js": 135,
	"./en-au": 136,
	"./en-au.js": 136,
	"./en-ca": 137,
	"./en-ca.js": 137,
	"./en-gb": 138,
	"./en-gb.js": 138,
	"./en-ie": 139,
	"./en-ie.js": 139,
	"./en-il": 140,
	"./en-il.js": 140,
	"./en-nz": 141,
	"./en-nz.js": 141,
	"./eo": 142,
	"./eo.js": 142,
	"./es": 143,
	"./es-do": 144,
	"./es-do.js": 144,
	"./es-us": 145,
	"./es-us.js": 145,
	"./es.js": 143,
	"./et": 146,
	"./et.js": 146,
	"./eu": 147,
	"./eu.js": 147,
	"./fa": 148,
	"./fa.js": 148,
	"./fi": 149,
	"./fi.js": 149,
	"./fo": 150,
	"./fo.js": 150,
	"./fr": 151,
	"./fr-ca": 152,
	"./fr-ca.js": 152,
	"./fr-ch": 153,
	"./fr-ch.js": 153,
	"./fr.js": 151,
	"./fy": 154,
	"./fy.js": 154,
	"./gd": 155,
	"./gd.js": 155,
	"./gl": 156,
	"./gl.js": 156,
	"./gom-latn": 157,
	"./gom-latn.js": 157,
	"./gu": 158,
	"./gu.js": 158,
	"./he": 159,
	"./he.js": 159,
	"./hi": 160,
	"./hi.js": 160,
	"./hr": 161,
	"./hr.js": 161,
	"./hu": 162,
	"./hu.js": 162,
	"./hy-am": 163,
	"./hy-am.js": 163,
	"./id": 164,
	"./id.js": 164,
	"./is": 165,
	"./is.js": 165,
	"./it": 166,
	"./it.js": 166,
	"./ja": 167,
	"./ja.js": 167,
	"./jv": 168,
	"./jv.js": 168,
	"./ka": 169,
	"./ka.js": 169,
	"./kk": 170,
	"./kk.js": 170,
	"./km": 171,
	"./km.js": 171,
	"./kn": 172,
	"./kn.js": 172,
	"./ko": 173,
	"./ko.js": 173,
	"./ky": 174,
	"./ky.js": 174,
	"./lb": 175,
	"./lb.js": 175,
	"./lo": 176,
	"./lo.js": 176,
	"./lt": 177,
	"./lt.js": 177,
	"./lv": 178,
	"./lv.js": 178,
	"./me": 179,
	"./me.js": 179,
	"./mi": 180,
	"./mi.js": 180,
	"./mk": 181,
	"./mk.js": 181,
	"./ml": 182,
	"./ml.js": 182,
	"./mn": 183,
	"./mn.js": 183,
	"./mr": 184,
	"./mr.js": 184,
	"./ms": 185,
	"./ms-my": 186,
	"./ms-my.js": 186,
	"./ms.js": 185,
	"./mt": 187,
	"./mt.js": 187,
	"./my": 188,
	"./my.js": 188,
	"./nb": 189,
	"./nb.js": 189,
	"./ne": 190,
	"./ne.js": 190,
	"./nl": 191,
	"./nl-be": 192,
	"./nl-be.js": 192,
	"./nl.js": 191,
	"./nn": 193,
	"./nn.js": 193,
	"./pa-in": 194,
	"./pa-in.js": 194,
	"./pl": 195,
	"./pl.js": 195,
	"./pt": 196,
	"./pt-br": 197,
	"./pt-br.js": 197,
	"./pt.js": 196,
	"./ro": 198,
	"./ro.js": 198,
	"./ru": 199,
	"./ru.js": 199,
	"./sd": 200,
	"./sd.js": 200,
	"./se": 201,
	"./se.js": 201,
	"./si": 202,
	"./si.js": 202,
	"./sk": 203,
	"./sk.js": 203,
	"./sl": 204,
	"./sl.js": 204,
	"./sq": 205,
	"./sq.js": 205,
	"./sr": 206,
	"./sr-cyrl": 207,
	"./sr-cyrl.js": 207,
	"./sr.js": 206,
	"./ss": 208,
	"./ss.js": 208,
	"./sv": 209,
	"./sv.js": 209,
	"./sw": 210,
	"./sw.js": 210,
	"./ta": 211,
	"./ta.js": 211,
	"./te": 212,
	"./te.js": 212,
	"./tet": 213,
	"./tet.js": 213,
	"./tg": 214,
	"./tg.js": 214,
	"./th": 215,
	"./th.js": 215,
	"./tl-ph": 216,
	"./tl-ph.js": 216,
	"./tlh": 217,
	"./tlh.js": 217,
	"./tr": 218,
	"./tr.js": 218,
	"./tzl": 219,
	"./tzl.js": 219,
	"./tzm": 220,
	"./tzm-latn": 221,
	"./tzm-latn.js": 221,
	"./tzm.js": 220,
	"./ug-cn": 222,
	"./ug-cn.js": 222,
	"./uk": 223,
	"./uk.js": 223,
	"./ur": 224,
	"./ur.js": 224,
	"./uz": 225,
	"./uz-latn": 226,
	"./uz-latn.js": 226,
	"./uz.js": 225,
	"./vi": 227,
	"./vi.js": 227,
	"./x-pseudo": 228,
	"./x-pseudo.js": 228,
	"./yo": 229,
	"./yo.js": 229,
	"./zh-cn": 230,
	"./zh-cn.js": 230,
	"./zh-hk": 231,
	"./zh-hk.js": 231,
	"./zh-tw": 232,
	"./zh-tw.js": 232
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 428;

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07452c71_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(375);
function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07452c71"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07452c71_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TodoHeader_vue__ = __webpack_require__(240);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'TodoHeader': __WEBPACK_IMPORTED_MODULE_0__components_TodoHeader_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_API__ = __webpack_require__(242);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      location: '',
      address: '',
      forecast: null,
      icons: {
        'clear-day': '🌞',
        'clear-night': '🌞',
        'rain': '☔',
        'snow': '⛄',
        'sleet': '❄',
        'wind': '🌀',
        'fog': '☁',
        'cloudy': '☁',
        'partly-cloudy-day': '⛅',
        'partly-cloudy-night': '⛅'
      }
    };
  },
  created: function created() {
    var _this = this;

    navigator.connection.addEventListener('change', this.getNetwork);

    navigator.geolocation.getCurrentPosition(function (location) {
      _this.loadWeather(location.coords.latitude, location.coords.longitude);
    });
  },

  methods: {
    loadWeather: function loadWeather(lat, lng) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__lib_API__["a" /* default */].getAddress(lat, lng).then(function (result) {
        _this2.address = [result.name, result.street].join(' ');
        //localStorage.address = this.address;
      });
      __WEBPACK_IMPORTED_MODULE_0__lib_API__["a" /* default */].getForecast(lat, lng).then(function (result) {
        _this2.forecast = result;
      });
    }
  },
  computed: {
    temperature: function temperature() {
      return Math.round((this.forecast.currently.temperature - 32) / 1.8);
    }
  }
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TodoList_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TodoNav_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_db_js__ = __webpack_require__(13);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    beforeCreate: function beforeCreate() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2__store_db_js__["a" /* authRef */].onAuthStateChanged(function (user) {
            if (!user) _this.$router.push('/');else {
                _this.$store.commit('userAuth', user);
            }
        });
    },

    components: {
        'TodoNav': __WEBPACK_IMPORTED_MODULE_1__TodoNav_vue__["a" /* default */],
        'TodoList': __WEBPACK_IMPORTED_MODULE_0__TodoList_vue__["a" /* default */]
    }
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_db_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Modal_vue__ = __webpack_require__(45);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selected: null,
      search: '',
      user: '',
      text: '',
      showModal: true
    };
  },

  methods: {
    removeTodo: function removeTodo(id) {
      if (confirm('Are you sure?')) {
        this.$store.dispatch('BinTodo', id);
      }
    },
    doneTodo: function doneTodo(todo) {
      this.$store.dispatch('DoneTodo', todo);
    }
  },
  computed: {
    filteredTodos: function filteredTodos() {
      var _this = this;

      return this.$store.getters.getTodos.filter(function (todo) {
        if (_this.user == todo.user && !todo.remove && !todo.status) {
          if (_this.selected == null) {
            _this.count++;
            return todo.title.match(_this.search);
          }
          if (todo.ctg == _this.selected) {
            return todo.title.match(_this.search);
          }
        }
      });
    },
    doneTodos: function doneTodos() {
      var _this2 = this;

      return this.$store.getters.getTodos.filter(function (todo) {
        if (_this2.user == todo.user && !todo.remove && todo.status) {
          if (_this2.selected == null) {
            return todo.title.match(_this2.search);
          }
          if (todo.ctg == _this2.selected) {
            return todo.title.match(_this2.search);
          }
        }
      });
    },
    deadlineTodos: function deadlineTodos() {
      var _this3 = this;

      var year = new Date().getFullYear();
      var month = new Date().getMonth();
      var date = new Date().getDate();
      var today = new Date(year + "-" + (month + 1) + "-" + date);

      return this.$store.getters.getTodos.filter(function (todo) {
        if (_this3.user == todo.user && !todo.remove && !todo.status) {
          var oneday = 24 * 60 * 60 * 1000;
          var deadline = new Date(todo.deadline);
          var diff = (deadline - today) / oneday;

          if (diff >= 0 && diff <= 2) {
            navigator.vibrate([2000, 1000]);
            return todo;
          }
        }
      });
    },
    ctgs: function ctgs() {
      return this.$store.getters.getCtgs;
    },
    done: function done() {
      var _this4 = this;

      var total = 0;
      var done = 0;
      this.$store.getters.getTodos.filter(function (todo) {
        if (_this4.user == todo.user && !todo.remove) total++;
        if (_this4.user == todo.user && !todo.remove && todo.status) done++;
      });
      if (done == 0) {
        return 0;
      } else {
        return Math.round(done / total * 100);
      }
    }
  },
  filters: {
    summarize: function summarize(value) {
      if (value.length > 10) {
        return value = value.substr(0, 10) + "......";
      } else {
        return value;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_0__store_db_js__["a" /* authRef */].onAuthStateChanged(function (user) {
      if (!user) _this5.$router.push('/');else {
        _this5.$store.commit('userAuth', user);
        _this5.user = _this5.$store.getters.getAuth.email;
      }
    });
  },
  created: function created() {
    this.$store.dispatch('getTodos');
    this.$store.dispatch('getCtgs');
  },

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__common_Modal_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoNav_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369a3e8d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoNav_vue__ = __webpack_require__(378);
function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-369a3e8d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodoNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369a3e8d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    logOut: function logOut() {
      this.$store.dispatch('logOut');
    },
    todoBin: function todoBin() {
      this.$router.push('bin');
    },
    todoList: function todoList() {
      this.$router.push('todo');
    },
    TodoCamera: function TodoCamera() {
      this.$router.push('camera');
    }
  },
  computed: {
    name: function name() {
      return this.$store.getters.getAuth.name;
    }
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_db_js__ = __webpack_require__(13);

//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            form: {
                email: '',
                name: ''
            },
            show: true
        };
    },

    methods: {
        gLogin: function gLogin() {
            this.$store.dispatch('userAuth');
        },
        onSubmit: function onSubmit(evt) {
            evt.preventDefault();
            alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form));
        },
        onReset: function onReset(evt) {
            var _this = this;

            evt.preventDefault();
            /* Reset our form values */
            this.form.email = '';
            this.form.name = '';
            /* Trick to reset/clear native browser form validation state */
            this.show = false;
            this.$nextTick(function () {
                _this.show = true;
            });
        }
    },
    beforeCreate: function beforeCreate() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_1__store_db_js__["a" /* authRef */].onAuthStateChanged(function (user) {
            if (user) {
                _this2.$router.push('todo');
            }
        });
    }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Modal_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_db_js__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        ctg: '',
        title: '',
        content: '',
        deadline: ''
      },
      showModal: false,
      showCtg: false,
      newCtg: '',
      user: ''
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      if (this.form.title !== "" && this.form.ctg !== "" && this.form.content !== "" && this.form.date !== "") {
        this.$store.dispatch('addTodo', this.form);
        this.clearInput();
        history.back();
      } else {
        this.showModal = !this.showModal;
      }
    },
    clearInput: function clearInput() {
      this.onReset();
    },
    onReset: function onReset() {
      this.form.ctg = null;
      this.form.title = '';
      this.form.content = null;
      this.form.deadline = null;
    },
    addCtg: function addCtg() {
      if (this.newCtg !== '') {
        this.$store.dispatch('addCtg', this.newCtg);
        this.newCtg = '';
      } else {
        alert("추가 할 카테고리명을 입력해주세요");
      }
    },
    deleteCtg: function deleteCtg(ctg) {
      this.$store.dispatch('removeCtg', ctg);
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__store_db_js__["a" /* authRef */].onAuthStateChanged(function (user) {
      if (!user) _this.$router.push('/');else {
        _this.$store.commit('userAuth', user);
        _this.user = _this.$store.getters.getAuth.email;
      }
    });
  },
  created: function created() {
    this.$store.dispatch('getCtgs');
  },

  computed: {
    ctgs: function ctgs() {
      var _this2 = this;

      return this.$store.getters.getCtgs.filter(function (ctg) {
        if (_this2.user == ctg.user) {
          return _this2.$store.getters.getCtgs;
        }
      });
    }
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__common_Modal_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_db_js__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        id: null,
        ctg: null,
        title: null,
        content: null,
        deadline: null
      }
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__store_db_js__["c" /* dbRef */].where('id', '==', this.$route.params.todo_id).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        _this.form.id = doc.data().id, _this.form.ctg = doc.data().ctg;
        _this.form.title = doc.data().title;
        _this.form.content = doc.data().content;
        _this.form.deadline = doc.data().deadline;
      });
    });
  }
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_db_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Modal_vue__ = __webpack_require__(45);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        id: '',
        ctg: '',
        title: '',
        content: '',
        deadline: ''
      },
      showModal: false
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.form.title !== "" && this.form.ctg !== "" && this.form.content !== "" && this.form.date !== "") {
        __WEBPACK_IMPORTED_MODULE_0__store_db_js__["c" /* dbRef */].where('id', '==', this.$route.params.todo_id).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            doc.ref.update({
              ctg: _this.form.ctg,
              title: _this.form.title,
              content: _this.form.content,
              deadline: _this.form.deadline
            }).then(function () {
              _this.$router.push({ name: 'Todoview', params: { todo_id: _this.form.id } });
            });
          });
        });
      } else {
        this.showModal = !this.showModal;
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$store.dispatch('getCtgs');
    __WEBPACK_IMPORTED_MODULE_0__store_db_js__["c" /* dbRef */].where('id', '==', this.$route.params.todo_id).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        _this2.form.id = doc.data().id;
        _this2.form.ctg = doc.data().ctg;
        _this2.form.title = doc.data().title;
        _this2.form.content = doc.data().content;
        _this2.form.deadline = doc.data().deadline;
      });
    });
  },

  computed: {
    ctgs: function ctgs() {
      return this.$store.getters.getCtgs;
    }
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__common_Modal_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_db_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TodoNav_vue__ = __webpack_require__(88);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    restoreTodo: function restoreTodo(id) {
      if (confirm('복원 하시겠습니까?')) {
        this.$store.dispatch('RestoreTodo', id);
      }
    },
    removeAll: function removeAll() {
      this.$store.dispatch('DeleteComplete');
    }
  },
  computed: {
    filteredTodos: function filteredTodos() {
      var _this = this;

      return this.$store.getters.getTodos.filter(function (todo) {
        if (_this.user == todo.user && todo.remove) {
          return todo.title.match(_this.search);
        }
      });
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__store_db_js__["a" /* authRef */].onAuthStateChanged(function (user) {
      if (!user) _this2.$router.push('/');else {
        _this2.$store.commit('userAuth', user);
        _this2.user = _this2.$store.getters.getAuth.email;
      }
    });
  },
  created: function created() {
    this.$store.dispatch('getTodos');
  },

  components: {
    'TodoNav': __WEBPACK_IMPORTED_MODULE_1__TodoNav_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        events: {
            default: function _default() {
                return [];
            }
        },

        eventSources: {
            default: function _default() {
                return [];
            }
        },

        editable: {
            default: function _default() {
                return true;
            }
        },

        selectable: {
            default: function _default() {
                return true;
            }
        },

        selectHelper: {
            default: function _default() {
                return true;
            }
        },

        header: {
            default: function _default() {
                return {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                };
            }
        },

        defaultView: {
            default: function _default() {
                return 'agendaWeek';
            }
        },

        sync: {
            default: function _default() {
                return false;
            }
        },

        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        defaultConfig: function defaultConfig() {
            var self = this;
            return {
                header: this.header,
                defaultView: this.defaultView,
                editable: this.editable,
                selectable: this.selectable,
                selectHelper: this.selectHelper,
                aspectRatio: 2,
                timeFormat: 'HH:mm',
                events: this.events,
                eventSources: this.eventSources,

                eventRender: function eventRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    self.$emit.apply(self, ['event-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                viewRender: function viewRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    self.$emit.apply(self, ['view-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDestroy: function eventDestroy(event) {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }
                },
                eventClick: function eventClick() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        args[_key3] = arguments[_key3];
                    }

                    self.$emit.apply(self, ['event-selected'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDrop: function eventDrop() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4];
                    }

                    self.$emit.apply(self, ['event-drop'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventReceive: function eventReceive() {
                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                        args[_key5] = arguments[_key5];
                    }

                    self.$emit.apply(self, ['event-receive'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventResize: function eventResize() {
                    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                        args[_key6] = arguments[_key6];
                    }

                    self.$emit.apply(self, ['event-resize'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                dayClick: function dayClick() {
                    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                        args[_key7] = arguments[_key7];
                    }

                    self.$emit.apply(self, ['day-click'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                select: function select(start, end, jsEvent, view, resource) {
                    self.$emit('event-created', {
                        start: start,
                        end: end,
                        allDay: !start.hasTime() && !end.hasTime(),
                        view: view,
                        resource: resource
                    });
                }
            };
        }
    },

    mounted: function mounted() {
        var _this = this;

        var cal = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el),
            self = this;

        this.$on('remove-event', function (event) {
            if (event && event.hasOwnProperty('id')) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event.id);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event);
            }
        });

        this.$on('rerender-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('rerenderEvents');
        });

        this.$on('refetch-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('refetchEvents');
        });

        this.$on('render-event', function (event) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('renderEvent', event);
        });

        this.$on('reload-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', _this.events);
        });

        this.$on('rebuild-sources', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEventSources');
            _this.eventSources.map(function (event) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', event);
            });
        });

        cal.fullCalendar(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default()(this.config, this.defaultConfig));
    },


    methods: {
        fireMethod: function fireMethod() {
            var _$;

            return (_$ = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el)).fullCalendar.apply(_$, arguments);
        }
    },

    watch: {
        events: {
            deep: true,
            handler: function handler(val) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('removeEvents');
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('addEventSource', this.events);
            }
        },
        eventSources: {
            deep: true,
            handler: function handler(val) {
                this.$emit('rebuild-sources');
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.$off('remove-event');
        this.$off('rerender-events');
        this.$off('refetch-events');
        this.$off('render-event');
        this.$off('reload-events');
        this.$off('rebuild-sources');
    }
});

/***/ })

},[234]);


// WEBPACK FOOTER //
// static/js/app.6a708ac5b05e1cf0e121.js